export default {
  help: {
    'a': ' 一、APP其他功能',
    'b': ' [首页]您可以查看最新测量信息，心率健康趋势，健康数据统计。',
    'c': '[历史]查看历史测量记录。',
    'd': '[测量]连接心电设备，获取测量数据结果。',
    'e': '[家人] 您可以替家人或朋友创建附属账号，还可以绑定家人或朋友已有账号，与他们一起使用本产品及服务。',
    'f': '[设置] 可进行账号相关设置。',
    'g': '二、设备电源管理',
    'h': '本设备处于待机状态时，闲置 3分钟便会自动关机，您也可以在使用完毕后，持续按压电源开关约 2秒关闭设备电源。当设备电量偏低时，会每 5秒“哔”一声进行提示，同时电源指示灯闪烁，此时仍可操作，但请您尽快进行充电。当设备电量极低时，开启后会长“哔”一声并即刻自动关机，此时请立即为设备充电。',
    'i': '三、注意事项',
    'j': '电池相关问题',
    'k': 'Q1.第一次使用心美特时需要充电多久？',
    'l': '第一次使用本设备时，请先充电3个小时。充电时将亮起绿色灯号，充电完毕灯号会自动熄灭。',
    'm': 'Q2. 如何帮心美特充电？',
    'n': '请使用原厂盒内micro USB充电线充电。将充电线插入设备充电口，并将另一头接连接到计算机USB接口或者输出电压为5V的手机充电器进行充电。',
    'o': 'Q3. 设备充满电后，电池续航时间大约为多久？',
    'p': '一般而言，若是使用频率是一天测量2次，续航时间大约为3个月左右。实际的续航状况会受测量及开关机的次数的影响，另外外部的环境的变化也会改变电池的电量，如在极冷或极热的温度下其可用电量会相对减少；此外，由于电池本身为消耗品，可用电量会随使用年限增加而渐渐变少。',
    'q': 'Q4. 当设备低电量时，会有任何警示吗？',
    'r': '当设备自动侦测到低电量时，会以每5秒“哔”1声方式告知，此时仍可进行量测，请量测完后尽快进行充电。',
    's': '当设备电量极低时，开启后会长哔1声并立即自动关机，此时请立即进行充电。',
    't': '心美特有自动关机省电设计，当设备闲置3分钟，会自动关机并发出“哔”1声以告知。',
    'u': '手机、平板与APP相关问题',
    'v': 'Q5. 如何注册与登录心美特APP？',
    'w': '您可以依照APP内指示进行注册与登录。',
    'x': 'Q6. 心美特如何与手机进行蓝牙配对？',
    'y': '请开启设备电源开关，并依照APP内指示进行蓝牙配对，或参考以下指示进行配对：',
    'z': '安卓用户',
    'aa': '1.开启设备电源进入待机状态',
    'bb': '2.在Android手机中设定→蓝牙→开启蓝牙',
    'cc': '3.扫描附近的装置，选取[CmateH]完成蓝牙配对',
    'dd': '苹果用户',
    'ee': '请先在设定中开启蓝牙功能，无须进行配对，直接配合APP使用即可。',
    'ff': '量测相关问题',
    'gg': 'Q7. 量测时，放置设备的正确位置是怎样的？',
    'hh': '请手持设备并“正面向上”轻压于胸口前位置（切勿倒置），四个接触点需稳定接触到皮肤。',
    'ii': 'Q8. 已按照图中标示的位置进行量测，为何无法成功？',
    'jj': '由于每个人的体型皆不同，若是无法从指南所建议的量测位置成功量测时，可以尝试将设备往左边平行位移至左边乳头上方的位置进行测量。',
    'kk': 'Q9. 其他量测不成功的可能原因是什么？',
    'll': '皮肤干燥：由于个人肤质因人而异，属于干性肤质的使用者，建议可以在皮肤均匀涂抹适量耦合剂以增加其量测成功率。',
    'mm': '皮肤潮湿：量测前请确认胸前皮肤无汗水附着，请擦干后再行量测。',
    'nn': '环境：由于设备是属于一种电生理信号的放大装置，因此请尽量避免在干扰源较大的环境下进行量测。',
    'oo': 'Q10. 量测时的正确姿势是怎样的？',
    'pp': '量测时采坐姿并能有靠背的椅子为佳，并将设备的四个接触点轻压并稳定接触到胸前皮肤。量测期间不要晃动身体、四肢或说话，当设备检测到心跳生理信号时会发出间断提示“哔”声，以识别量测信号的质量。',
    'qq': 'Q11. 为什么在量测时，“哔”声时有时无？这是正常的吗？',
    'rr': '若在量测时发生侦测心跳的哔声时有时无，则表示量测采集的信号不完整；可能是在量测中因手或身体的晃动而导致接触点无法正常接触到皮肤，若遇此情形请重新量测，直到在30秒的纪录中都能听到此提示音为止，再进行上传分析。',
    'ss': 'Q12. 什么是心率健康、情绪与精神状态、疲劳指数？',
    'tt': '将量测30秒所纪录的数据，通过设备AI计算分析技术，快速呈现出的心率变异状态，并以不同颜色来表示其量测当下的结果；心率健康是反应其规律性状态变化，情绪与精神状态及疲劳指数乃是反应其生理、心理的健康状态指标。',
    'uu': 'Q13. 在APP内已有量测功能键，为何在设备本体上还有一个「量测按键」呢？',
    'vv': '在一般情况下，使用者可以依照APP的指引来操作在手机或平板电脑内APP的量测按钮进行量测；若使用者暂时没有手机或平板电脑，却有量测需求时，则可以使用此「量测按键」进行量测与纪录，待之后再用手机或平板电脑按下APP内的「上传」功能键将测量记录上传；此种方式，也可适用于来不及打开APP，但必须要及时量测的手动上传模式。',
    'ww': 'Q14. 请问使用者可以以平躺姿势进行量测吗?',
    'xx': '使用者可以以平躺的姿势进行量测。此时若不方便同时操作APP时，可采用手动上传模式进行；也可请旁人协助操作APP，直接以APP来进行量测上传。',
    'yy': '设备相关问题',
    'zz': '15. 上传成功的测量记录是储存在云端上还是在设备内？',
    'aaa': '上传成功的测量记录会在设备端自动删除并储存在云端上，然而若是在上传测量记录时因网络信号不佳而无法上传成功时，该未上传的记录会储存在设备内，待网络信号稳定时，可再行上传。设备内可供储存量测记录为30笔，当纪录额满时，将无法使用本装置，必须删除部分或全部的记录，才可正常运作。',
    'bbb': 'Q16. 设备开机后无法使用且每秒发出2次“哔”声？',
    'ccc': '表示设备内存储的记录已满，此时必须使用APP内上传功能中的删除键进行部分或全部删除后，方能正常使用。',
    'ddd': 'Q17. 设备是否有防水功能？',
    'eee': '设备本身并不支持防水功能，请尽量避免在潮湿的环境下使用。',
    'fff': 'Q18. 设备是否要定期清理？',
    'ggg': '由于设备的4个金属接触点必须直接接触到皮肤，因此长期使用后金属接触点表面会沾黏到身体的皮屑或油脂，而影响其导电性；此时可用棉花棒沾湿清洁或是用沾有稀释酒精成分的布进行清洁，再擦干即可。',
    'hhh': 'Q19. 为什么量测时间会出现异常，例如出现过去时间的状况？',
    'iii': '这是设备本身未与手机或平板电脑的时间同步所致，此情况可能发生于当用户第一次使用装置进行量测，但于当下并未开启手机或平板的APP，待量测完毕后再行开启APP上传，此时在APP上所显示的量测时间会与上传时间差异很大。建议进行第二次量测，此时设备会与手机或平板电脑的时间同步，即可解决时间异常问题。',
    'jjj': '若想了解更多产品信息，请扫描下方二维码，关注【盖德健康】微信服务号。'
  }
}
